/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PatchPccDemographicsResponse } from './PatchPccDemographicsResponse';
import {
    PatchPccDemographicsResponseFromJSON,
    PatchPccDemographicsResponseFromJSONTyped,
    PatchPccDemographicsResponseToJSON,
} from './PatchPccDemographicsResponse';

/**
 * 
 * @export
 * @interface PatchPccDemographics200Response
 */
export interface PatchPccDemographics200Response {
    /**
     * 
     * @type {PatchPccDemographicsResponse}
     * @memberof PatchPccDemographics200Response
     */
    data?: PatchPccDemographicsResponse;
}

/**
 * Check if a given object implements the PatchPccDemographics200Response interface.
 */
export function instanceOfPatchPccDemographics200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PatchPccDemographics200ResponseFromJSON(json: any): PatchPccDemographics200Response {
    return PatchPccDemographics200ResponseFromJSONTyped(json, false);
}

export function PatchPccDemographics200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchPccDemographics200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : PatchPccDemographicsResponseFromJSON(json['data']),
    };
}

export function PatchPccDemographics200ResponseToJSON(value?: PatchPccDemographics200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': PatchPccDemographicsResponseToJSON(value.data),
    };
}

